import React from "react";
import { Col,Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // <-- Add this

export default function DistributeDashboardRecord({ data }) {
    const navigate = useNavigate(); // <-- For navigation

    const handleCardClick = (key) => {
        navigate(`/distibuted-family-list/${key}`);
    };

    const totalFamiliesRecord = [
        {
            key: "verification-distributed",
            icon: "card_membership",
            trend: "card_membership",
            title: "Distributed For Verification",
            variant: "blue",
            number: data?.families_for_verification?.distributed,
        },
        {
            key: "verification-total",
            icon: "price_change",
            trend: "price_change",
            title: "TOTAL VERIFIED",
            variant: "green",
            number: data?.families_for_verification?.verified,
        },
        {
            key: "verification-pending",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Pending Verifications",
            variant: "purple",
            number: data?.families_for_verification?.count,
        },
        {
            key: "non-verified",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Non Verified",
            variant: "purple",
            number: data?.families_for_verification?.count,
        },
        {
            key: "rescue-distributed",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Distributed For Rescue",
            variant: "blue",
            number: data?.families_for_rescue?.distributed,
        },
        {
            key: "rescue-total",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Total Rescued",
            variant: "green",
            number: data?.families_for_rescue?.rescued,
        },
        {
            key: "rescue-pending",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Pending For Rescue",
            variant: "purple",
            number: data?.families_for_rescue?.count,
        },
          {
            key: "non-rescued",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Non Rescued",
            variant: "purple",
            number: data?.families_for_rescue?.count,
        },
        {
            key: "business-distributed",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Distributed For Business",
            variant: "blue",
            number: data?.families_for_business?.distributed,
        },
        {
            key: "business-total",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Total Granted",
            variant: "green",
            number: data?.families_for_business?.granted,
        },
        {
            key: "business-pending",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Pending For Business",
            variant: "purple",
            number: data?.families_for_business?.count,
        },
         {
            key: "Follow-Up-distributed",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Distributed For Follow-Up",
            variant: "blue",
            number: data?.families_for_business?.distributed,
        },
        {
            key: "Follow-Up-total",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Total Granted",
            variant: "green",
            number: data?.families_for_business?.granted,
        },
        {
            key: "Follow-Up-pending",
            icon: "account_balance_wallet",
            trend: "account_balance_wallet",
            title: "Pending For Follow-Up",
            variant: "purple",
            number: data?.families_for_business?.count,
        },

        
    ];

 const getCardColor = (title) => {
  const lowerTitle = title.toLowerCase();

  if (lowerTitle.includes("distributed")) return "#3399FF"; // Medium Blue
  if (lowerTitle.includes("pending")) return "#FFB84D";     // Medium Orange
  if (lowerTitle.includes("total")) return "#4CAF50";       // Medium Green

  return "red"; // Medium Red for default / not verified
};


const getbgColor = (title) => {
  if (title.toLowerCase().includes("distributed"))
    return "linear-gradient(135deg, #b3e6b3 0%, #77dd77 100%)"; // soft green gradient
  if (title.toLowerCase().includes("pending"))
    return "linear-gradient(135deg, #b3e0ff 0%, #6ec6ff 100%)"; // soft blue gradient
  if (title.toLowerCase().includes("total"))
    return "linear-gradient(135deg, #ffb3b3 0%, #ff7f7f 100%)"; // soft red gradient

  return "linear-gradient(135deg, #ffe0b3 0%, #ffb366 100%)"; // lighter orange gradient
};




    return (
       <>

<div className="card d-flex flex-column p-0 mb-4">
  <div className="card-header"
  style={{backgroundColor:"#077834"}}>
    <h3 className="card-title text-light">Verification Families Overview</h3>
  </div>

  <Row className="gx-3 gy-3">
    {totalFamiliesRecord
      .filter(item => item.key.includes("verification"))
      .map((item, index) => (
        <Col md={4} key={index} className="px-2 pt-4">

          {item.key === "verification-total" ? (
  <div
    className="mc-ecommerce-card d-flex flex-column p-4"
    style={{ cursor: "pointer", height: "150px", border: `2px solid #eee`,borderRadius:"10px" }}
  >
    {/* <i
                className="mc-ecommerce-card-trend material-icons z-0"
                style={{ color: "rgba(211, 211, 211, 0.4)"}}
              >
                {item.trend}
              </i> */}
    <div className="d-flex justify-content-between ">
     {["verification-total", "non-verified"].map((keyName, index) => {
  const section = totalFamiliesRecord.find(item => item.key === keyName);
  if (!section) return null; 

  return (
    <div
      key={keyName}
      className={`text-center flex-fill ${index === 0 ? "me-2" : "ms-2"} p-2`}
      style={{
        border: "2px solid #eee",
        borderRadius: "0px 20px 0px 20px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        onHover: {
          background: getbgColor(section.title)
        }
      }}
onClick={() => {
  console.log("Clicked:", section.key);
  handleCardClick(section.key);
}}
    >
      
      <h1 className="fw-bold"
      style={{color:getCardColor(section.title)}}>{section.number}</h1>
      <h5 className=" fw-bold"
      style={{ color:"#4a4a4a" }}>{section.title}</h5>
      
    </div>
  );
})}

    </div>
   
  </div>
) : (
            // Render other cards normally
            <div
            className="main-card mc-ecommerce-card d-flex flex-row align-items-center justify-content-center p-4"
            style={{ cursor: "pointer", height: "150px", border: `2px solid #eee`,
            borderRadius:"10px"
           }}
            onClick={() => handleCardClick(item.key)}
          >
            {/* Trend icon */}
            <div style={{opacity:0.2}}> <i
                className="mc-ecommerce-card-trend material-icons z-0"
style={{ color: "#077834" }}              >
                {item.trend}
              </i>
</div>
             
            {/* Number & Title */}
           

            {/* Secondary icon */}
           <div className="d-flex  flex-column justify-content-center align-items-center z-3">
              <h1 className="text-center fs-1"
              style={{ color: getCardColor(item.title) }}>{item.number}</h1>
              <h3 className="text-center "
               style={{ color:"#4a4a4a" }}>{item.title}</h3>
            </div>

         </div>
          )}
        </Col>
      ))}
  </Row>
</div>


<div className="card d-flex p-0 flex-column mb-4">
  <div className="card-header "
  style={{backgroundColor:"#077834"}}>
    <h3 className="card-title text-light">Rescue Families Overview</h3>
  </div>

  <Row className="gx-3 gy-3">
    {totalFamiliesRecord
      .filter(item => item.key.includes("rescue")  && item.key !== "non-rescued" )
      .map((item, index) => (
        <Col md={4} key={index} className="px-2 pt-4">

          {item.key === "rescue-total"? (
  <div
    className="mc-ecommerce-card d-flex flex-column p-4"
    style={{ cursor: "pointer", height: "150px", border: `2px solid #eee`,
  borderRadius:"10px" }}
  >
    {/* <i
                className="mc-ecommerce-card-trend material-icons z-0"
                style={{ color: "rgba(211, 211, 211, 0.4)" }}
              >
                {item.trend}
              </i> */}
    <div className="d-flex justify-content-between">
     {["rescue-total", "non-rescued"].map((keyName, index) => {
  const section = totalFamiliesRecord.find(item => item.key === keyName);
  if (!section) return null; 

  return (
    <div
      key={keyName}
      className={`text-center flex-fill ${index === 0 ? "me-2" : "ms-2"} p-2`}
      style={{
        border:"2px solid #eee" ,
        borderRadius: "0px 20px 0px 20px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
      }}
onClick={() => {
  console.log("Clicked:", section.key);
  handleCardClick(section.key);
}}
    >
      <h1 className=""
      style={{color:getCardColor(section.title)}}
      >{section.number}</h1>
      <h5 className="fw-bold"
      style={{ color:"#4a4a4a" }}>{section.title}</h5>
    </div>
  );
})}

    </div>
   
  </div>
) : (
            // Render other cards normally
            <div
            className="mc-ecommerce-card d-flex flex-row align-items-center justify-content-center p-4"
            style={{ cursor: "pointer", height: "150px", border: `2px solid #eee`,
          borderRadius: "10px" }}
            onClick={() => handleCardClick(item.key)}
          >
            {/* Trend icon */}
            <div style={{opacity:0.2}}> <i
                className="mc-ecommerce-card-trend material-icons z-0"
style={{ color: "#077834" }}              >
                {item.trend}
              </i>
</div>
             
            {/* Number & Title */}
           

            {/* Secondary icon */}
           <div className="d-flex   flex-column justify-content-center align-items-center z-3">
              <h1 className="text-center fs-1"
              style={{ color: getCardColor(item.title) }}>{item.number}</h1>
              <h3 className="text-center word- "
               style={{ color:"#4a4a4a" }}>{item.title}</h3>
            </div>

         </div>
          )}
        </Col>
      ))}
  </Row>
</div>
  


 {/* Business Cards */}

<div className="card d-flex flex-column mb-4 p-0">
  <div className="card-header m-0"
  style={{backgroundColor:"#077834"}}>
    <h3 className="card-title text-light">Business Overview</h3>
  </div>

  <Row className="gx-3 gy-3 p-1">
    {totalFamiliesRecord
      .filter(item => item.key.includes("business"))
      .map((item, index) => (
        <Col md={4} key={index} className="px-2 pt-4">
          <div
            className="mc-ecommerce-card d-flex flex-row align-items-center justify-content-center p-4"
            style={{ cursor: "pointer", height: "150px", border: `2px solid #eee`,
          borderRadius: "0px 20px 0px 20px" }}
            onClick={() => handleCardClick(item.key)}
          >
            {/* Trend icon */}
            <div style={{opacity:0.2}}> <i
                className="mc-ecommerce-card-trend material-icons z-0"
style={{ color: "#077834" }}              >
                {item.trend}
              </i>
</div>
             
            {/* Number & Title */}
           

            {/* Secondary icon */}
           <div className="d-flex  flex-column justify-content-center align-items-center  ">
              <h1 className="text-center fs-1"
              style={{ color: getCardColor(item.title) }}>{item.number}</h1>
              <h3 className="text-center  "
               style={{ color:"#4a4a4a" }}>{item.title}</h3>
            </div>

         </div>
        </Col>
      ))}
  </Row>
</div>

{/* Follow UpCrad */}

<div className="card p-0 d-flex flex-column mb-4">
  <div className="card-header"
  style={{backgroundColor:"#077834"}}>
    <h3 className="card-title text-light">Follow Up Overview</h3>
  </div>

  <Row className="gx-3 gy-3 p-1">
    {totalFamiliesRecord
      .filter(item => item.key.includes("Follow-Up"))
      .map((item, index) => (
        <Col md={4} key={index} className="px-2 pt-4">
          <div
            className="mc-ecommerce-card d-flex flex-row align-items-center justify-content-center p-4"
            style={{ cursor: "pointer", height: "150px", border: `2px solid #eee` }}
            onClick={() => handleCardClick(item.key)}
          >
            {/* Trend icon */}
            <div style={{opacity:0.2}}> <i
                className="mc-ecommerce-card-trend material-icons z-0"
style={{ color: "#077834" }}              >
                {item.trend}
              </i>
</div>
             
            {/* Number & Title */}
           

            {/* Secondary icon */}
           <div className="d-flex  flex-column justify-content-center align-items-center  ">
              <h1 className="text-center fs-1"
              style={{ color: getCardColor(item.title) }}>{item.number}</h1>
              <h3 className="text-center  "
               style={{ color:"#4a4a4a" }}>{item.title}</h3>
            </div>

         </div>
        </Col>
      ))}
  </Row>
</div>


 
</>

    );
}
